// Przycisk konta użytkownika z dropdownem
// @ts-nocheck

import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Person, BoxArrowRight, JournalText, PersonCircle } from "react-bootstrap-icons";
import classnames from "classnames";

import { useAppNavigate } from "hooks";
import { usePostOverLogout } from "api";
import { useDispatch, reduxActions, useSelector } from "store";
import { DropDown } from "components/controls";

import styles from "theme/components/containers/UserAccountButton/UserAccountButton.module.scss";

const UserAccountButton = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useAppNavigate();
  const { overloginUserId } = useSelector((state) => state.auth);

  const { mutateAsync } = usePostOverLogout();

  // wylogowanie użytkownika z systemu
  const handleLogout = async () => { 
    if (overloginUserId) {
      // zawsze po przełączeniu użytkownika wracamy na stronę główną
      navigate("/", { replace: true });
      await mutateAsync();

      dispatch(reduxActions.setCurrentCartId(null));
      dispatch(reduxActions.setOverlogin(null));

      return;
    }
    dispatch(reduxActions.signOut());
  };

  const isDashboardActive = location.pathname.includes("dashboard");
  const isOrdersActive = location.pathname.includes("/dashboard/orders");
  const isMyAccountActive = location.pathname.includes("/dashboard/my-account");

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        "StylePath-Components-Containers-UserAccountButton"
      )}
    >
      <DropDown
        label={
          <span
            className={classnames(styles.label, {
              [styles.active]: isDashboardActive,
            })}
          >
            <Person className={styles.personIcon} />{" "}
            {t("Twoje konto")}
          </span>
        }
        items={[
          {
            label: (
              <span
                className={classnames(styles.menuItem, {
                  [styles.active]: isDashboardActive,
                })}
              >
                <Person className={styles.menuIcon} />
                {t("Dashboard")}
              </span>
            ),
            onClick: () => {
              navigate("/dashboard");
            },
          },
          {
            label: (
              <span
                className={classnames(styles.menuItem, {
                  [styles.active]: isOrdersActive,
                })}
              >
                <JournalText className={styles.menuIcon} />
                {t("Zamówienia")}
              </span>
            ),
            onClick: () => {
              navigate("/dashboard/orders");
            },
          },
          {
            label: (
              <span
                className={classnames(styles.menuItem, {
                  [styles.active]: isMyAccountActive,
                })}
              >
                <PersonCircle className={styles.menuIcon} />
                {t("Moje konto")}
              </span>
            ),
            onClick: () => {
              navigate("/dashboard/my-account");
            },
          },
          {
            label: (
              <span className={styles.menuItem}>
                <BoxArrowRight className={styles.menuIcon} />
                {overloginUserId ? t("Wróć na konto") : t("Wyloguj")}
              </span>
            ),
            onClick: handleLogout,
          },
        ]}
        withDropdownIcon={true}
      />
    </div>
  );
};

export default UserAccountButton;
